
import { AIStaffMember } from "@/lib/types";
import { staffMapper } from "@/api/staff/mappers";

export function useStaffConverter() {
  /**
   * Legacy converter function that uses the new mapper
   * For backward compatibility
   */
  const convertStaffData = (staffData: any): AIStaffMember => {
    return staffMapper.toFrontend(staffData);
  };

  return {
    convertStaffData
  };
}
